export default __webpack_public_path__ + "static/media/October_07.20a35511.png";